// Utilidad para formatear cantidades monetarias con soporte multiidioma

/**
 * Formatea una cantidad como moneda EUR usando el locale del idioma activo
 * @param {number} amount - Cantidad a formatear
 * @param {string} lang - Código de idioma (ej: 'es', 'en')
 * @returns {string} Cantidad formateada con símbolo €
 */
export const formatCurrency = (amount, lang = 'es') => {
  return new Intl.NumberFormat(lang, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount) + '€';
};

/**
 * Formatea un número con separadores de miles según el locale activo (sin símbolo)
 * @param {number} amount - Número a formatear
 * @param {string} lang - Código de idioma
 * @returns {string} Número formateado
 */
export const formatNumber = (amount, lang = 'es') => {
  return new Intl.NumberFormat(lang, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};
